import { render, staticRenderFns } from "./OneInstr.vue?vue&type=template&id=c99b85f2&scoped=true&"
import script from "./OneInstr.vue?vue&type=script&lang=js&"
export * from "./OneInstr.vue?vue&type=script&lang=js&"
import style0 from "./OneInstr.vue?vue&type=style&index=0&id=c99b85f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99b85f2",
  null
  
)

export default component.exports